import React from 'react';
import './ServiceSection.css';

// You can replace these image imports with real ones
import visaImg from '../asset/visa2.png';
import loanImg from '../asset/loan.png';
import counsellingImg from '../asset/councelling.png';
import universityImg from '../asset/univer.png';
import jobImg from '../asset/job.png';
import admissionImg from '../asset/admission.png';
import accommodationImg from '../asset/acomodation.png';
import pickupImg from '../asset/pick.png';
import posterImg from '../asset/europe.jpeg';

const services = [
  {
    image: visaImg,
    title: 'Visa Processing',
    description: 'We provide comprehensive support in preparing and submitting visa applications, including documentation and interview guidance.',
  },
  {
    image: loanImg,
    title: 'Education Loan',
    description: 'We guide students in securing education loans and coordinate with lenders for best financial solutions.',
  },
  {
    image: counsellingImg,
    title: 'Overseas Education Counselling',
    description: 'We offer personalized guidance to help students choose the right course, university, and country.',
  },
  {
    image: universityImg,
    title: 'Country Program & University Selection',
    description: 'We assist in selecting the ideal study destination, program, and university based on your career goals.',
  },
  {
    image: jobImg,
    title: 'Job Assistance',
    description: 'We support students in finding jobs, resume building, and interview prep for kickstarting global careers.',
  },
  {
    image: admissionImg,
    title: 'Application & Admission Assistance',
    description: 'We handle form submission, document prep, and ensure accurate, timely admissions abroad.',
  },
  {
    image: accommodationImg,
    title: 'Accommodation',
    description: 'We help find safe and comfortable housing options abroad—on-campus and off-campus.',
  },
  {
    image: pickupImg,
    title: 'Airport Pickup',
    description: 'We arrange reliable airport pickups and ensure a smooth and safe transition to student accommodations.',
  },
];

const ServicesSection = () => {
  return (
    <section id="services">
      <div className="services-header">
        <h1>Our Services</h1>
      </div>

      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.image} alt={service.title} />
            <div className="service-content">
              <h2>{service.title}</h2>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="poster-section">
        <img src={posterImg} alt="Study in Europe Poster" />
      </div>

    </section>
  );
};

export default ServicesSection;